import { SET_MERCH_LIST, SET_INDEX } from './mutation-type'

export default {
    [SET_MERCH_LIST](state, data) {
        state.merch.list = data

    },
    [SET_INDEX](state, data) {
        state.currIndex = data
    }
}